export const statusCheckHandler = (reports, userId) => {
  let statuses = [];
  let riskFactor = "";

  const processReport = (report) => {
    const result = report.result;
    // Check if result is one of the invalid values
    const isInvalid =
      result === "" ||
      result === "N/A" ||
      result === "Not Found" ||
      result === "Nill" ||
      result === "---" ||
      result === "NAD";
    const parsedResult = parseFloat(result);

    switch (report.investigation_id) {
      // Hemoglobin
      case 15:
        if (isInvalid || (parsedResult >= 11 && parsedResult <= 16.5)) {
          statuses.push(2);
          report.status = 2;
        } else if (parsedResult >= 1 && parsedResult <= 10.9) {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">Hemoglobin</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">Hemoglobin</span>, ';
          report.status = 3;
        }
        break;

      // R.B.S
      case 16:
        if (isInvalid || (parsedResult >= 60 && parsedResult <= 160)) {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">R.B.S</span>, ';
          report.status = 4;
        }
        break;

      // S. Creatinine
      case 17:
        if (isInvalid || (parsedResult >= 0.2 && parsedResult <= 1.36)) {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">S. Creatinine</span>, ';
          report.status = 4;
        }
        break;

      // S.Bilirubin
      case 20:
        if (isInvalid || (parsedResult >= 0.2 && parsedResult <= 1.35)) {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">S. Bilirubin</span>, ';
          report.status = 4;
        }
        break;

      // Malarial Parasite
      case 25:
        if (isInvalid || result === "Not Found") {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">Malarial Parasite</span>, ';
          report.status = 3;
        }
        break;

      // VDRL
      case 27:
        if (isInvalid || result === "Non Reactive") {
          statuses.push(2);
          report.status = 2;
        } else if (result === "W. Reactive") {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">VDRL</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">VDRL</span>, ';
          report.status = 3;
        }
        break;

      // Pregnancy Test
      case 22:
        if (isInvalid || result === "Negative") {
          statuses.push(2);
          report.status = 2;
        } else if (result === "Positive") {
          statuses.push(3);
          riskFactor += '<span style="color: red;">Pregnancy</span>, ';
          report.status = 3;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">Pregnancy</span>, ';
          report.status = 4;
        }
        break;

      // SGPT
      case 23:
        if (isInvalid || (parsedResult >= 1 && parsedResult <= 58)) {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">SGPT</span>, ';
          report.status = 4;
        }
        break;

      // SGOT
      case 24:
        if (isInvalid || (parsedResult >= 1 && parsedResult <= 55)) {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">SGOT</span>, ';
          report.status = 4;
        }
        break;

      // TPHA
      case 28:
        if (isInvalid || result === "Negative") {
          statuses.push(2);
          report.status = 2;
        } else if (result === "W. Positive" || result === "Equvocal") {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">TPHA</span>, ';
          report.status = 4;
        } else if (result === "Repeat") {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">TPHA</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">TPHA</span>, ';
          report.status = 3;
        }
        break;

      // Anti-HCV
      case 29:
        if (isInvalid || result === "Negative") {
          statuses.push(2);
          report.status = 2;
        } else if (
          result === "W. Positive" ||
          result === "Equvocal" ||
          result === "Repeat"
        ) {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">Anti-HCV</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">Anti-HCV</span>, ';
          report.status = 3;
        }
        break;

      // HIV 1 - 2
      case 30:
        if (isInvalid || result === "Negative") {
          statuses.push(2);
          report.status = 2;
        } else if (
          result === "W. Positive" ||
          result === "Equvocal" ||
          result === "Repeat"
        ) {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">HIV 1 - 2</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">HIV 1 - 2</span>, ';
          report.status = 3;
        }
        break;

      // HBsAg
      case 26:
        if (isInvalid || result === "Negative") {
          statuses.push(2);
          report.status = 2;
        } else if (
          result === "W. Positive" ||
          result === "Equvocal" ||
          result === "Repeat"
        ) {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">HBsAg</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">HBsAg</span>, ';
          report.status = 3;
        }
        break;

      // Bilharziasis (THC in original)
      case 37:
        if (isInvalid || result === "Negative") {
          statuses.push(2);
          report.status = 2;
        } else if (result === "W. Positive") {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">THC</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">THC</span>, ';
          report.status = 3;
        }
        break;

      // MOP
      case 38:
        if (isInvalid || result === "Negative") {
          statuses.push(2);
          report.status = 2;
        } else if (result === "W. Positive") {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">MOP</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">MOP</span>, ';
          report.status = 3;
        }
        break;

      // Others (AMP in original)
      case 40:
        if (isInvalid || result === "Negative") {
          statuses.push(2);
          report.status = 2;
        } else if (result === "W. Positive") {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">Others</span>, ';
          report.status = 4;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">Others</span>, ';
          report.status = 3;
        }
        break;

      // CU Sugar
      case 21:
        if (isInvalid || result === "Nill") {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">CU Sugar</span>, ';
          report.status = 4;
        }
        break;

      // Albumin
      case 42:
        if (isInvalid || result === "Nill") {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">Albumin</span>, ';
          report.status = 4;
        }
        break;

      // Microfilaria
      case 41:
        if (isInvalid || result === "Absent") {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">Microfilaria</span>, ';
          report.status = 3;
        }
        break;

      // Leishmaniasis
      case 48:
        if (isInvalid || result === "Absent") {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(3);
          riskFactor += '<span style="color: red;">Leishmaniasis</span>, ';
          report.status = 3;
        }
        break;

      // Platelet
      case 49:
        if (isInvalid || (parsedResult >= 150000 && parsedResult <= 450000)) {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">Platelet</span>, ';
          report.status = 4;
        }
        break;

      // Urea
      case 18:
        if (isInvalid || (parsedResult >= 5 && parsedResult <= 24)) {
          statuses.push(2);
          report.status = 2;
        } else {
          statuses.push(4);
          riskFactor += '<span style="color: #0000FF;">Urea</span>, ';
          report.status = 4;
        }
        break;

      default:
        break;
    }
  };

  // Process each report
  reports.forEach(processReport);

  // Set risk factor comments
  const pathologyRiskFactor = {
    user_id: userId,
    comments: riskFactor,
    investigation_group_id: 102,
  };

  // Determine final status based on priority (3 > 4 > 2 > 1)
  let finalStatus;
  if (statuses.includes(3)) {
    finalStatus = 3;
  } else if (statuses.includes(4)) {
    finalStatus = 4;
  } else if (statuses.includes(2)) {
    finalStatus = 2;
  } else {
    finalStatus = 1;
  }

  return {
    status: finalStatus,
    pathologyRiskFactor,
    reports,
  };
};
